import styled from 'styled-components';

import { IconProps } from '@components/icons';
import { IconAddPlus } from '@components/icons/add-plus';
import { IconBrandADManager } from '@components/icons/brand-ad-manager';
import { IconBrandAsana } from '@components/icons/brand-asana';
import { IconBrandAvia } from '@components/icons/brand-avia';
import { IconBrandDokobit } from '@components/icons/brand-dokobit';
import { IconBrandEloomi } from '@components/icons/brand-eloomi';
import { IconBrandGetAccept } from '@components/icons/brand-getaccept';
import { IconBrandH3 } from '@components/icons/brand-h3';
import { IconBrandHireflix } from '@components/icons/brand-hireflix';
import { IconBrandHRMonitor } from '@components/icons/brand-hrmonitor';
import { IconBrandKjarni } from '@components/icons/brand-kjarni';
import { IconBrandMyTimePlan } from '@components/icons/brand-mytimeplan';
import { IconBrandOneSystems } from '@components/icons/brand-onesystems';
import { IconBrandPersonio } from '@components/icons/brand-personio';
import { IconBrandRelesys } from '@components/icons/brand-relesys';
import { IconBrandReykjavik } from '@components/icons/brand-reykjavik';
import { IconBrandRU } from '@components/icons/brand-ru';
import { IconBrandSAP } from '@components/icons/brand-sap';
import { IconBrandSignet } from '@components/icons/brand-signet';
import { IconBrandSiminnPay } from '@components/icons/brand-siminnpay';
import { IconBrandSlack } from '@components/icons/brand-slack';
import { IconBrandTaktikal } from '@components/icons/brand-taktikal';
import { IconBrandTimon } from '@components/icons/brand-timon';
import { IconBrandWorkplace } from '@components/icons/brand-workplace';
import { IconContract } from '@components/icons/contract';
import { IconData } from '@components/icons/data';
import { IconInternalTasklist } from '@components/icons/internal-tasklist';
import { IconOnboarding } from '@components/icons/onboarding';

import Raido from 'components/icons/raido.png';
import Teachable from 'components/icons/teachable.png';

export const IntegrationIconSvgs = {
  'AD Manager': IconBrandADManager,
  'Document Validation': IconData,
  'Eloomi Monitor': IconBrandEloomi,
  'Finish Contract': IconBrandRU,
  'HR Monitor': IconBrandHRMonitor,
  'Internal Tasklists': IconInternalTasklist,
  'Onboarding Form': IconOnboarding,
  'SAP XML': IconBrandSAP,
  'Síminn Pay': IconBrandSiminnPay,
  AddNew: IconAddPlus,
  Asana: IconBrandAsana,
  Contract: IconContract,
  Dokobit: IconBrandDokobit,
  Eloomi: IconBrandEloomi,
  GetAccept: IconBrandGetAccept,
  H3core: IconBrandH3,
  Hireflix: IconBrandHireflix,
  Kjarni: IconBrandKjarni,
  MyTimePlan: IconBrandMyTimePlan,
  OneSystem: IconBrandOneSystems,
  Personio: IconBrandPersonio,
  Relesys: IconBrandRelesys,
  SAP: IconBrandSAP,
  Signet: IconBrandSignet,
  Slack: IconBrandSlack,
  Taktikal: IconBrandTaktikal,
  Tímon: IconBrandTimon,
  Workplace: IconBrandWorkplace,
  OneCRM: IconBrandOneSystems,
  Avia: IconBrandAvia,
  Ráðningarsamningur: IconBrandReykjavik,
  Hlaðan: IconBrandReykjavik,
  'Reykjavík SAP': IconBrandSAP,
};

const IntegrationIconPngs = {
  Raido,
  Teachable,
};

type SvgKey = keyof typeof IntegrationIconSvgs;
type PngKey = keyof typeof IntegrationIconPngs;

export type IntegrationKey = SvgKey | PngKey;

type IntegrationIconProps = {
  integrationName: IntegrationKey;
  size?: string | number;
  color?: IconProps['color'];
};

export const IntegrationIcon = ({
  integrationName,
  size = 40,
  color = 'inherit',
}: IntegrationIconProps) => {
  const Icon = IntegrationIconSvgs[integrationName as SvgKey];
  const iconPng = IntegrationIconPngs[integrationName as PngKey];

  return (
    <Container size={size}>
      {Icon ? (
        <Icon color={color} size={size} />
      ) : (
        <img src={iconPng} alt={integrationName} width="100%" height="100%" />
      )}
    </Container>
  );
};

const Container = styled.div<Pick<IntegrationIconProps, 'size'>>((p) => ({
  maxWidth: p.size,
  maxHeight: p.size,
  minWidth: p.size,
  minHeight: p.size,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: p.color,
}));
